// extracted by mini-css-extract-plugin
export var dot = "H_b5";
export var dotAnimate = "H_b7";
export var dotBlue = "H_b9";
export var dotGreen = "H_b8";
export var rotation = "H_b6";